import { render, staticRenderFns } from "./jskr.vue?vue&type=template&id=8da5bb8a&scoped=true&"
import script from "./jskr.vue?vue&type=script&lang=js&"
export * from "./jskr.vue?vue&type=script&lang=js&"
import style0 from "./jskr.vue?vue&type=style&index=0&id=8da5bb8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da5bb8a",
  null
  
)

export default component.exports